import consumer from "./consumer"

export const subscribeToAuction = (auctionId, onEndTimeUpdate) => {
  return consumer.subscriptions.create(
    { channel: "AuctionChannel", auction_id: auctionId },
    {
      received(data) {
        const subscriptionAuctionId = this.identifier ? (JSON.parse(this.identifier).auction_id || auctionId) : auctionId;
        const auctionEndTimeElement = document.getElementById("auction-end-time");
        if (auctionEndTimeElement && data.ad_publication_date) {
          auctionEndTimeElement.innerText = `${data.ad_publication_date}`;
        }
        if (onEndTimeUpdate && data.remaining_time) {
          onEndTimeUpdate(data.remaining_time);
        }
        if (data.offers_partial) {
          const offersTableBody = document.getElementById("offers-table-body");
          if (offersTableBody) {
            offersTableBody.innerHTML = data.offers_partial;
            // Personalize "Your bid" display for current user
            personalizeBidTable(offersTableBody);
            // Update "Your bid at the moment" from the updated table
            updateYourBidFromTable(subscriptionAuctionId);
            
            // Dispatch custom event to notify that DOM was updated
            // This allows other scripts (like select2setup.js) to reinitialize if needed
            const domUpdateEvent = new CustomEvent('auctionTableUpdated', {
              detail: { auctionId: subscriptionAuctionId }
            });
            document.dispatchEvent(domUpdateEvent);
          }
        }
        if (data.offer_bid) {
          const auctionOfferField = document.getElementById("auction_offer");
          if (auctionOfferField) {
            auctionOfferField.value = data.offer_bid;
          }
        }
        if (data.highest_ad_bid) {
          const highestAdBidElement = document.getElementById("highest-ad-bid");
          if (highestAdBidElement) {
            highestAdBidElement.innerText = `${data.highest_ad_bid} €`;
          }
          
          const highestAdBidHiddenField = document.getElementById("highest_ad_bid");
          if (highestAdBidHiddenField) {
            highestAdBidHiddenField.value = data.highest_ad_bid.replace(/[^\d,.-]/g, '').replace(',', '.');
          }
          
          const auctionContainers = document.querySelectorAll(`.items-type-1[data-auction-id]`);
          auctionContainers.forEach(auctionContainer => {
            const containerAuctionId = auctionContainer.getAttribute('data-auction-id');
            if (containerAuctionId === String(subscriptionAuctionId)) {
              const highestBidElement = auctionContainer.querySelector(`#highest_bid_${containerAuctionId}`) || document.getElementById(`highest_bid_${containerAuctionId}`);
              if (highestBidElement) {
                let currencySign = 'EUR';
                const currentText = highestBidElement.textContent || '';
                const currencyMatch = currentText.match(/(EUR|€|\$|£|¥)/i);
                if (currencyMatch) {
                  currencySign = currencyMatch[1];
                } else {
                  const yourBidElement = auctionContainer.querySelector(`#your_bid_${containerAuctionId}`);
                  if (yourBidElement) {
                    const yourBidText = yourBidElement.textContent || '';
                    const yourBidCurrencyMatch = yourBidText.match(/(EUR|€|\$|£|¥)/i);
                    if (yourBidCurrencyMatch) {
                      currencySign = yourBidCurrencyMatch[1];
                    }
                  }
                }
                highestBidElement.textContent = `${data.highest_ad_bid} ${currencySign}`;
              }
            }
          });
          
          const wishlistOfferField = document.getElementById(`wishlist_offer_${subscriptionAuctionId}`);
          if (wishlistOfferField && data.offer_bid) {
            wishlistOfferField.value = data.offer_bid;
          }
        }
        
        if (data.highest_bid !== undefined) {
          const formatHighestBid = (value) => {
            if (!value && value !== 0) return '';
            const numValue = parseFloat(value) || 0;
            if (typeof addThousandSeparators === 'function') {
              return addThousandSeparators(numValue.toString());
            } else {
              const parts = numValue.toFixed(2).split('.');
              const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
              return `${integerPart},${parts[1]}`;
            }
          };
          
          const formattedHighestBid = formatHighestBid(data.highest_bid);
          const auctionContainers = document.querySelectorAll(`.items-type-1[data-auction-id]`);
          auctionContainers.forEach(auctionContainer => {
            const containerAuctionId = auctionContainer.getAttribute('data-auction-id');
            if (containerAuctionId === String(subscriptionAuctionId)) {
              const bidOfferFields = auctionContainer.querySelectorAll('[id^="bid_offer_amount_"]');
              bidOfferFields.forEach(bidOfferField => {
                bidOfferField.value = formattedHighestBid;
              });
            }
          });
        }
        
        if (data.new_offer_user_id !== undefined) {
          const auctionContainers = document.querySelectorAll(`.items-type-1[data-auction-id]`);
          auctionContainers.forEach(auctionContainer => {
            const containerAuctionId = auctionContainer.getAttribute('data-auction-id');
            if (containerAuctionId === String(subscriptionAuctionId)) {
              const userFields = auctionContainer.querySelectorAll('[id^="user_id_"]');
              userFields.forEach(userField => {
                const currentUserId = parseInt(userField.value);
                if (currentUserId === data.new_offer_user_id) {
                  const yourBidElement = auctionContainer.querySelector(`#your_bid_${containerAuctionId}`);
                  if (yourBidElement) {
                    const currencySign = yourBidElement.textContent.match(/[€$£¥]/)?.[0] || '€';
                    // Use user_highest_bid_amount if available (user's highest bid), otherwise fall back to new_offer_amount
                    const bidAmount = data.user_highest_bid_amount !== undefined && data.user_highest_bid_amount !== null 
                      ? data.user_highest_bid_amount 
                      : (data.new_offer_amount || '-----------');
                    yourBidElement.innerHTML = `${bidAmount} ${currencySign}`;
                  }
                }
              });
            }
          });
        }
        
        if (data.highest_bidder_user_id !== undefined) {
          const publicUserField = document.getElementById("user_id");
          const publicCurrentUserHasHighestBidField = document.getElementById("current_user_has_highest_bid");
          if (publicUserField && publicCurrentUserHasHighestBidField) {
            const currentUserId = parseInt(publicUserField.value);
            publicCurrentUserHasHighestBidField.value = currentUserId === data.highest_bidder_user_id;
          }
          
          const auctionContainers = document.querySelectorAll(`.items-type-1[data-auction-id]`);
          auctionContainers.forEach(auctionContainer => {
            const containerAuctionId = auctionContainer.getAttribute('data-auction-id');
            if (containerAuctionId === String(subscriptionAuctionId)) {
              const userFields = auctionContainer.querySelectorAll('[id^="user_id_"]');
              userFields.forEach(userField => {
                const suffix = userField.id.replace('user_id_', '');
                const currentUserHasHighestBidField = auctionContainer.querySelector(`#current_user_has_highest_bid_${suffix}`);
                if (currentUserHasHighestBidField) {
                  const currentUserId = parseInt(userField.value);
                  currentUserHasHighestBidField.value = currentUserId === data.highest_bidder_user_id;
                }
              });
            }
          });
        }
      }
    }
  );
};

// Personalize bid table to show "Your bid" for current user's bids
function personalizeBidTable(tableBody) {
  const userField = document.getElementById("user_id");
  if (!userField || !userField.value) {
    return; // No current user, keep server-rendered content
  }
  
  const currentUserId = parseInt(userField.value);
  if (!currentUserId) {
    return;
  }
  
  // Get "Your bid" translation - try to get from a data attribute or use default
  const yourBidText = tableBody.getAttribute('data-your-bid-text') || 'Your bid';
  
  // Find all table rows
  const rows = tableBody.querySelectorAll('tr[data-user-id]');
  
  rows.forEach(row => {
    const rowUserId = parseInt(row.getAttribute('data-user-id'));
    if (isNaN(rowUserId)) {
      return; // Skip rows without valid user ID
    }
    
    const isOwnBid = rowUserId === currentUserId;
    const isHighest = row.getAttribute('data-is-highest') === 'true';
    
    // Get all cells in the row
    const cells = row.querySelectorAll('td');
    const userCell = row.querySelector('td.offer-user');
    
    if (isOwnBid) {
      // Update styling for own bids (pink and bold)
      const pinkColor = '#D30074';
      const boldPinkStyle = `font-weight: bold; color: ${pinkColor} !important;`;
      
      // Update all cells in the row to pink and bold
      cells.forEach(cell => {
        cell.style.cssText = boldPinkStyle;
      });
      
      // Update user column to show "Your bid" (override any server-rendered text)
      if (userCell) {
        userCell.innerHTML = yourBidText;
      }
    } else {
      // For other users' bids, use default styling (pink for highest, black for others)
      const bgColor = isHighest ? '#D30074' : '#222120';
      const defaultStyle = `color: ${bgColor} !important;`;
      
      // Remove bold styling and apply appropriate color
      cells.forEach(cell => {
        cell.style.cssText = defaultStyle;
      });
      
      // Ensure user cell shows user ID (not "Your bid" from server-side rendering)
      // This handles the case where server rendered "Your bid" for a different user
      if (userCell) {
        const userMonetId = row.getAttribute('data-user-monet-id');
        const hasAutoRaiser = row.getAttribute('data-has-auto-raiser') === 'true';
        
        if (userMonetId) {
          // Reconstruct the user ID display
          if (hasAutoRaiser) {
            userCell.innerHTML = `ID #${userMonetId} <br/>Auto raiser`;
          } else {
            userCell.innerHTML = `ID #${userMonetId}`;
          }
        }
      }
    }
  });
}

// Update "Your bid at the moment" by finding the user's highest bid in the table
function updateYourBidFromTable(auctionId) {
  const userField = document.getElementById("user_id");
  if (!userField || !userField.value) {
    return; // No current user
  }
  
  const currentUserId = parseInt(userField.value);
  if (!currentUserId) {
    return;
  }
  
  const offersTableBody = document.getElementById("offers-table-body");
  if (!offersTableBody) {
    return;
  }
  
  // Find all rows with the current user's ID
  const userRows = offersTableBody.querySelectorAll(`tr[data-user-id="${currentUserId}"]`);
  if (userRows.length === 0) {
    return;
  }
  
  // Find the highest bid amount for this user
  let highestBidAmount = 0;
  userRows.forEach(row => {
    const offerAmount = parseFloat(row.getAttribute('data-offer-amount')?.replace(/[^\d,.-]/g, '').replace(',', '.') || '0');
    if (offerAmount > highestBidAmount) {
      highestBidAmount = offerAmount;
    }
  });
  
  if (highestBidAmount > 0) {
    // Format the amount (add thousand separators)
    const formatAmount = (value) => {
      const parts = value.toFixed(2).split('.');
      const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return `${integerPart},${parts[1]}`;
    };
    
    const formattedAmount = formatAmount(highestBidAmount);
    
    // Update "Your bid at the moment" in wishlist/active bids views
    const auctionContainers = document.querySelectorAll(`.items-type-1[data-auction-id]`);
    auctionContainers.forEach(auctionContainer => {
      const containerAuctionId = auctionContainer.getAttribute('data-auction-id');
      if (containerAuctionId === String(auctionId)) {
        const yourBidElement = auctionContainer.querySelector(`#your_bid_${containerAuctionId}`);
        if (yourBidElement) {
          const currencySign = yourBidElement.textContent.match(/[€$£¥]/)?.[0] || '€';
          yourBidElement.innerHTML = `${formattedAmount} ${currencySign}`;
        }
      }
    });
  }
}

// Export personalizeBidTable so it can be called on page load
export function personalizeBidTableOnLoad() {
  const offersTableBody = document.getElementById("offers-table-body");
  if (offersTableBody) {
    personalizeBidTable(offersTableBody);
    // Also update "Your bid at the moment" on page load
    const auctionElement = document.getElementById("auction-id");
    if (auctionElement) {
      const auctionId = auctionElement.dataset.auctionId;
      if (auctionId) {
        updateYourBidFromTable(auctionId);
      }
    }
  }
}

const activeSubscriptions = new Map();

export const subscribeToAllAuctionsOnPage = () => {
  const auctionContainers = document.querySelectorAll('[data-auction-id]');
  
  auctionContainers.forEach(container => {
    const auctionId = container.getAttribute('data-auction-id');
    if (auctionId && !activeSubscriptions.has(auctionId)) {
      try {
        const subscription = subscribeToAuction(auctionId);
        if (subscription) {
          activeSubscriptions.set(auctionId, subscription);
        }
      } catch (e) {
        // Silently handle subscription errors
      }
    }
  });
  
  // Personalize bid table on initial page load
  personalizeBidTableOnLoad();
};

